// Client-safe metadata shared by the Exchange UI, public deal pages and the
// server-side matching engine.

export const LISTING_TYPES = [
  "product_offer",
  "product_demand",
  "invest_ask",
  "invest_offer",
  "service_offer",
  "service_demand",
  "partnership",
  "license_offer",
  "license_demand",
  "business_sale",
  "business_buy",
] as const;
export type ListingType = (typeof LISTING_TYPES)[number];

// Which listing types a given type should be matched against. Partnership is
// symmetric — partnerships match other partnerships.
export const COMPLEMENT: Record<ListingType, ListingType[]> = {
  product_offer: ["product_demand"],
  product_demand: ["product_offer"],
  invest_ask: ["invest_offer"],
  invest_offer: ["invest_ask"],
  service_offer: ["service_demand"],
  service_demand: ["service_offer"],
  partnership: ["partnership"],
  license_offer: ["license_demand"],
  license_demand: ["license_offer"],
  business_sale: ["business_buy"],
  business_buy: ["business_sale"],
};

export const TYPE_LABELS: Record<ListingType, { label: string; hue: string }> = {
  product_offer: { label: "Sell a product", hue: "168" },
  product_demand: { label: "Source products", hue: "60" },
  invest_ask: { label: "Raise capital", hue: "290" },
  invest_offer: { label: "Invest capital", hue: "240" },
  service_offer: { label: "Offer a service", hue: "20" },
  service_demand: { label: "Find a supplier", hue: "330" },
  partnership: { label: "Strategic partnership", hue: "200" },
  license_offer: { label: "License out IP", hue: "140" },
  license_demand: { label: "Find technology / IP", hue: "100" },
  business_sale: { label: "Sell a business (M&A)", hue: "350" },
  business_buy: { label: "Acquire a business", hue: "310" },
};

export function fmtAmount(min: number | null, max: number | null, currency: string): string | null {
  const f = (n: number) =>
    n >= 1_000_000
      ? `${+(n / 1_000_000).toFixed(1)}M`
      : n >= 1000
        ? `${+(n / 1000).toFixed(0)}k`
        : String(n);
  if (min != null && max != null) return `${f(min)}–${f(max)} ${currency}`;
  if (min != null) return `from ${f(min)} ${currency}`;
  if (max != null) return `up to ${f(max)} ${currency}`;
  return null;
}
